module.exports = __webpack_public_path__ + "img/fifth_step.a9d8b1c4.png";